var _defs, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    version: 1.1,
    viewBox: "0 0 244.8 244.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "sc0",
    cx: 122.4,
    cy: 122.4,
    r: 119.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "sc1",
    cx: 122.4,
    cy: 122.4,
    r: 119.9
  })));
};
export default __webpack_public_path__ + "static/media/select_category_REV3.4e5139bd.svg";
export { SvgComponent as ReactComponent };